import { render, staticRenderFns } from "./MembershipChangeStatusDetails.vue?vue&type=template&id=51f489f1&scoped=true&"
import script from "./MembershipChangeStatusDetails.vue?vue&type=script&lang=js&"
export * from "./MembershipChangeStatusDetails.vue?vue&type=script&lang=js&"
import style0 from "./MembershipChangeStatusDetails.vue?vue&type=style&index=0&id=51f489f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f489f1",
  null
  
)

export default component.exports